/* SneakCare — animations et comportements des sections sur mesure.
   Sur ordinateur, Horizon fait défiler .page-wrapper (pas la fenêtre) : on écoute donc le défilement
   en phase de capture sur document, ce qui attrape les deux cas. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasIO = 'IntersectionObserver' in window;

  /* 1. Apparitions */
  function initReveal(root) {
    const els = root.querySelectorAll('.sc-reveal:not(.is-visible)');
    if (reduce || !hasIO) { els.forEach((el) => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  }

  /* 3. Vidéo du premier écran : ordinateur uniquement, hors « économie de données », seulement quand elle est visible */
  function initHeroVideo(root) {
    root.querySelectorAll('video[data-sc-video]').forEach((video) => {
      const saveData = navigator.connection && navigator.connection.saveData;
      if (reduce || saveData || !window.matchMedia('(min-width: 990px)').matches) return;
      if (!video.dataset.loaded) {
        [['webm', 'video/webm'], ['mp4', 'video/mp4']].forEach(([k, type]) => {
          const src = video.dataset[k];
          if (!src) return;
          const s = document.createElement('source'); s.src = src; s.type = type; video.appendChild(s);
        });
        video.dataset.loaded = '1';
        video.load();
      }
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      const play = () => { const p = video.play(); if (p && p.catch) p.catch(() => {}); };
      if (!hasIO) { play(); return; }
      new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) play(); else video.pause(); });
      }, { threshold: 0.15 }).observe(video);
    });
  }

  /* 4. Barre d'achat flottante : apparaît après le premier écran, se cache sur l'offre et le pied de page */
  function initSticky() {
    const bar = document.querySelector('[data-sc-sticky]');
    if (!bar || !hasIO) return;
    const after = document.querySelector(bar.dataset.after || '.sc-hero, .product-information');
    const hiders = [...document.querySelectorAll(bar.dataset.hide || '#offre, .sc-footer, .footer')];
    let pastStart = false;
    const visibleHiders = new Set();
    const render = () => bar.classList.toggle('is-shown', pastStart && visibleHiders.size === 0);
    if (after) {
      new IntersectionObserver(([e]) => {
        pastStart = !e.isIntersecting && e.boundingClientRect.top < 0;
        render();
      }).observe(after);
    }
    const ioH = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) visibleHiders.add(e.target); else visibleHiders.delete(e.target); });
      render();
    }, { threshold: 0.05 });
    hiders.forEach((h) => ioH.observe(h));
    const btn = bar.querySelector('[data-sc-scroll]');
    if (btn) {
      btn.addEventListener('click', (ev) => {
        const sel = btn.dataset.scScroll || '';
        const target = sel.startsWith('#') ? document.querySelector(sel) : null;
        if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
      });
    }
  }

  /* 5. « Pourquoi l'adorer » : la mascotte commente la carte survolée ; sinon elle les présente à tour de rôle
        tant que la section est visible. Un clic sur elle la fait sauter (et parler). */
  function initWhy(root) {
    root.querySelectorAll('[data-sc-why]').forEach((wrap) => {
      const bubble = wrap.querySelector('.sc-why__bubble');
      const text = wrap.querySelector('[data-sc-bubble]');
      const btn = wrap.querySelector('[data-sc-tickle]');
      const mascot = wrap.querySelector('.scm');
      const items = [...wrap.querySelectorAll('[data-sc-why-card]')];
      const dots = [...wrap.querySelectorAll('.sc-why__dots span')];
      if (!bubble || !text || !items.length) return;
      const intro = text.textContent.trim();
      let current = -1, timer = null, talkT = null, swapT = null, userTook = false, visible = false;
      const restart = (cls, ms) => {
        if (!mascot || reduce) return;
        mascot.classList.remove(cls); void mascot.getBoundingClientRect(); mascot.classList.add(cls);
        return setTimeout(() => mascot.classList.remove(cls), ms);
      };
      const talk = () => { clearTimeout(talkT); talkT = restart('is-talking', 1600); };
      const say = (line) => {
        clearTimeout(swapT);
        if (reduce) { text.textContent = line; return; }
        bubble.classList.add('is-changing');
        swapT = setTimeout(() => { text.textContent = line; bubble.classList.remove('is-changing'); talk(); }, 200);
      };
      const activate = (i) => {
        if (i === current) return;
        current = i;
        items.forEach((c, n) => c.classList.toggle('is-active', n === i));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        say(i < 0 ? intro : (items[i].dataset.line || items[i].querySelector('h3').textContent));
      };
      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => {
        if (reduce || userTook || timer || !visible || !('autoplay' in wrap.dataset)) return;
        timer = setInterval(() => activate((current + 1) % items.length), 4200);
      };
      items.forEach((c, n) => {
        const take = () => { userTook = true; stop(); activate(n); };
        c.addEventListener('mouseenter', take);
        c.addEventListener('click', take);
      });
      if (btn) {
        btn.addEventListener('click', () => {
          userTook = true; stop(); restart('is-jump', 750);
          current = -2;
          items.forEach((c) => c.classList.remove('is-active'));
          dots.forEach((d) => d.classList.remove('is-active'));
          say(btn.dataset.scTickle || intro);
        });
      }
      if (hasIO) {
        new IntersectionObserver(([e]) => {
          visible = e.isIntersecting;
          if (visible) { talk(); setTimeout(start, 2400); } else stop();
        }, { threshold: 0.3 }).observe(wrap);
      }
    });
  }

  /* 6. Fiche produit : les formules en cartes pilotent le sélecteur de variantes de Horizon (masqué).
        Écoute déléguée : Horizon remplace le bloc à chaque changement de variante. */
  document.addEventListener('change', (e) => {
    const input = e.target.closest && e.target.closest('[data-sc-formule]');
    if (!input) return;
    const group = input.closest('.sc-formules');
    if (group) group.querySelectorAll('.sc-formule').forEach((l) => l.classList.toggle('is-selected', l.contains(input)));
    const root = input.closest('.product-details') || document;
    const radio = root.querySelector(`variant-picker input[type="radio"][data-variant-id="${input.value}"]`);
    if (radio) { if (!radio.checked) radio.click(); return; }
    const option = root.querySelector(`variant-picker select option[data-variant-id="${input.value}"]`);
    if (option) { const select = option.closest('select'); select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  const init = (root = document) => { initReveal(root); initHeroVideo(root); initWhy(root); };
  const boot = () => { init(); initSticky(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Éditeur de thème : ré-initialiser quand une section est rechargée.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
